const PALETTE = {
  backgroundGrey: '#b2b2b2',
  black: '#1A1A1A',
  footerGrey: '#EDEDED',
  greyscale10: '#e5e5e5',
  greyscale20: '#CCC',
  greyscale5: '#F2F2F2',
  greyscale60: '#666',
  greyscale70: '#4d4d4d',
  greyscale95: '#F5F5F5',
  lightGrey: '#D9D9D9',
  midGrey: '#D1D1D1',
  systemBlue: '#0066CC',
  systemButtonGrey: '#e6e6e6',
  systemDarkBlue: '#002142',
  systemFocusBlue: '#009ADB',
  systemMidBlue: '#00478F',
  systemPurple: '#551A8B',
  systemYellow: '#FFD440',
  topicGrey: '#666666',
  warning: '#FFD440',
  warningRed: '#cd0000',
  white: '#FFFFFF',
}

export default {
  palette: PALETTE,
}
